var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoveExpandVertical = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.62 9.61a1.24 1.24 0 0 0 1.76 0l6.44-6.42a.25.25 0 0 1 .36 0l6.44 6.42a1.245 1.245 0 0 0 1.76-1.76L12.88.37a1.24 1.24 0 0 0-1.76 0l-7.5 7.48a1.24 1.24 0 0 0 0 1.76Zm16.76 4.78a1.24 1.24 0 0 0-1.76 0l-6.44 6.42a.25.25 0 0 1-.36 0l-6.44-6.42a1.244 1.244 0 1 0-1.76 1.76l7.5 7.48a1.23 1.23 0 0 0 1.76 0l7.5-7.48a1.24 1.24 0 0 0 0-1.76Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})))));
export { SvgMoveExpandVertical as ReactComponent };
export default __webpack_public_path__ + "baae9f856445e21fb186cefc43620b3a6e095754709b979204f366a70d2e6dfa.svg";